import React from 'react'
import Navbar from '../../component/Other/Navbar'
import Contact from '../../component/Page/Contact'
import Footer from '../../component/Page/Footer'
import SecFaq from '../../component/Page/Faq'
import ContactForm from '../../component/Page/ContactForm'

const Faq = () => {
    return (
        <div className="overflow-hidden">
            <Navbar type={"dark"} />

            <SecFaq />

            <ContactForm />

            <Contact />

            <Footer />
        </div >
    )
}

export default Faq